import { AxiosConfigSuperAdmin } from "SuperAdmin/Config/AxiosConfig";
import { refreshToken } from "Explore/Services/Auth";

export const getAllRoles = (page, rowsPerPage, filters, callback) => {
  const axios = AxiosConfigSuperAdmin();
  let url = `/roles/?page=${page}&rowsPerPage=${rowsPerPage}`;
  if (filters.entity_id) {
    url += `&entity_id=${filters.entity_id}`;
  }
  if (filters.entity_type) {
    url += `&entity_type=${filters.entity_type}`;
  }
  if (filters.institution_id) {
    url += `&institution_id=${filters.institution_id}`;
  }
  if (filters.type) {
    url += `&type=${filters.type}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getAllRoles(page, rowsPerPage, filters, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const getRolesSearch = (filters, callback) => {
  const axios = AxiosConfigSuperAdmin();
  let url = `/roles/suggest/?`;
  if (filters.query) {
    url += `query=${filters.query}&`;
  }
  if (filters.entity_id) {
    url += `entity_id=${filters.entity_id}&`;
  }
  if (filters.entity_type) {
    url += `entity_type=${filters.entity_type}&`;
  }
  if (filters.institution_id) {
    url += `institution_id=${filters.institution_id}&`;
  }
  if (filters.type) {
    url += `type=${filters.type}&`;
  }
  url = url.slice(0, url.length - 1);
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getAllRoles(filters, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const getRoleInformationById = (
  id,

  callback
) => {
  const axios = AxiosConfigSuperAdmin();
  const url = `/roles/${id}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => getRoleInformationById(id, callback));
      } else {
        callback(err.response.data);
      }
    });
};
export const createRole = (payload, callback) => {
  const axios = AxiosConfigSuperAdmin();
  let url = `/roles`;
  axios
    .post(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => createRole(payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};

export const updateRole = (id, payload, callback) => {
  const axios = AxiosConfigSuperAdmin();
  let url = `/roles/${id}`;
  axios
    .put(url, payload)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      if (err.response.status === 401) {
        refreshToken(() => updateRole(id, payload, callback));
      } else {
        callback(err.response.data);
      }
    });
};
